/**
 * <plp-variant-selector>
 * Keeps the product-card variant dropdown (the submitted `name="id"` field) and the
 * desktop segmented pills in sync so the correct variant is added to cart from the PLP.
 */
if (!customElements.get("plp-variant-selector")) {
	customElements.define(
		"plp-variant-selector",
		class PlpVariantSelector extends HTMLElement {
			constructor() {
				super();

				this.select = this.querySelector(".plp-variant__select");
				this.pills = Array.from(this.querySelectorAll(".plp-variant__pill"));

				if (this.select) {
					this.select.addEventListener("change", () => this.syncPills(this.select.value));
				}

				this.pills.forEach((pill) => {
					pill.addEventListener("click", () => this.onPillClick(pill));
				});
			}

			onPillClick(pill) {
				if (pill.getAttribute("aria-disabled") === "true") return;
				if (!this.select) return;

				this.select.value = pill.dataset.variantId;
				this.select.dispatchEvent(new Event("change", { bubbles: true }));
			}

			syncPills(variantId) {
				this.pills.forEach((pill) => {
					const isSelected = pill.dataset.variantId === String(variantId);
					pill.classList.toggle("is-selected", isSelected);
					pill.setAttribute("aria-pressed", isSelected);
				});
			}
		}
	);
}
